import type { ErrorType } from "~/models/IResponse";

const BusinessExceptions: [ErrorType] = ["ValidationError"];

export const isBusinessException = (errorType: ErrorType): boolean => {
    return BusinessExceptions.includes(errorType);
};
